import { CookieService } from '@alfresco/adf-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WkCookieService {
  constructor(private readonly cookieService: CookieService) {}

  getItem(key: string): string | null {
    const value = this.cookieService.getItem(key);
    console.log(`🍪 getItem('${key}'):`, value);
    console.log('📋 All cookies:', document.cookie);
    return value;
  }

  setItem(
    key: string,
    data: string,
    expiration?: Date | null,
    path?: string | null
  ) {
    console.log(`🍪 setItem('${key}', '${data}')`, { expiration, path });
    return this.cookieService.setItem(key, data, expiration, path);
  }

  deleteCookie(key: string, path?: string | null) {
    console.log(`🍪 deleteCookie('${key}')`);
    this.cookieService.deleteCookie(key, path);
  }
}
